import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBIkcnvaQI511QYvX3r6Bkseb8CWeYR6sw",
  authDomain: "shooinstars-3b1de.firebaseapp.com",
  databaseURL: "https://shooinstars-3b1de-default-rtdb.firebaseio.com",
  projectId: "shooinstars-3b1de",
  storageBucket: "shooinstars-3b1de.appspot.com", // ✅ THIS ONE
  messagingSenderId: "629892906204",
  appId: "1:629892906204:web:3af6e8a450654d18cf8819",
};

const app = initializeApp(firebaseConfig);

export const db = getDatabase(app);
export const storage = getStorage(app);
